
export const REGEX_CONSTANTS = {
    SPECIAL_REGEX: /[!@#$%^&*()+=._-]/,
    UPPERCASE_REGEX: /[A-Z]/,
    NUMBER_REGEX: /[0-9]/
}